var _path, _rect, _line, _line2, _line3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgReportsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 30,
    viewBox: "0 0 24 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.06672 4H3C1.89543 4 1 4.89543 1 6V27C1 28.1046 1.89543 29 3 29H21C22.1046 29 23 28.1046 23 27V6C23 4.89543 22.1046 4 21 4H18",
    stroke: "white",
    strokeWidth: 1.2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.6,
    y: 0.6,
    width: 12.8,
    height: 5.8,
    rx: 1.4,
    stroke: "white",
    strokeWidth: 1.2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 6.91562,
    y1: 25.4,
    x2: 6.91563,
    y2: 10.6,
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 12.4,
    y1: 25.4,
    x2: 12.4,
    y2: 15.6,
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 17.4,
    y1: 25.4,
    x2: 17.4,
    y2: 20.6,
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsIcon);
export default __webpack_public_path__ + "static/media/ReportsIcon.97cbd06278af1dd3e1bc012d4b79fed4.svg";
export { ForwardRef as ReactComponent };